import { Box, Typography, Grid } from "@mui/material";
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';

const NO_DISPONIBLE = '—';

// "sep 2026" a partir de la fecha en que la persona creó su cuenta
const mesYAnio = (fecha) => {
  const d = fecha ? new Date(fecha) : null;
  return d && !Number.isNaN(d.getTime())
    ? new Intl.DateTimeFormat('es-MX', { month: 'short', year: 'numeric' }).format(d)
    : NO_DISPONIBLE;
};

// reputacion = { serviciosRealizados, evaluaciones, identidadVerificada } (datos reales del servidor);
// llega null mientras carga o si falla, y entonces se muestra "—" en vez de inventar cifras.
const ExperienceStats = ({ user, reputacion }) => {
  const numero = (n) => (reputacion ? Number(n).toLocaleString('es-MX') : NO_DISPONIBLE);
  const verificado = Boolean(reputacion?.identidadVerificada);

  const stats = [
    {
      label: "SERVICIOS REALIZADOS",
      value: numero(reputacion?.serviciosRealizados),
      icon: <LocalShippingOutlinedIcon sx={{ color: 'primary.main', fontSize: 28 }} />,
    },
    {
      label: "EVALUACIONES",
      value: numero(reputacion?.evaluaciones),
      icon: <StarBorderOutlinedIcon sx={{ color: 'primary.main', fontSize: 28 }} />,
    },
    {
      label: "MIEMBRO DESDE",
      value: mesYAnio(user?.date),
      icon: <CalendarMonthOutlinedIcon sx={{ color: 'primary.main', fontSize: 28 }} />,
    },
    {
      label: "IDENTIDAD",
      value: reputacion ? (verificado ? "Verificado" : "Sin verificar") : NO_DISPONIBLE,
      icon: <VerifiedUserOutlinedIcon sx={{ color: verificado ? 'primary.main' : 'text.secondary', fontSize: 28 }} />,
    }
  ];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main', mb: 0.5 }}>
        Experiencia One Service
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', display: 'block', mb: 3 }}>
        Experiencia como proveedor
      </Typography>

      <Box className="stats-container-row">
        <Grid container spacing={3}>
          {stats.map((stat, index) => (
            <Grid key={index} size={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left', textAlign: 'left' }}>
                <Box sx={{ mb: 1.5 }}>
                  {stat.icon}
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    color: 'text.secondary',
                    fontWeight: 600,
                    mb: 0.5,
                    fontSize: '0.7rem'
                  }}
                >
                  {stat.label}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    fontSize: '1.25rem'
                  }}
                >
                  {stat.value}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ExperienceStats;
